import { Input } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorWhite, ColorGray700, ColorTextError, ColorCostcoBlue, RadiusSm, ColorGray400, ButtonsSizeHeight, ColorGray200, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const buttonGroupStyles = {
  display: "flex",
  paddingBottom: "0 !important",
  "& .buttonLeft": {
    borderRadius: `${RadiusSm} 0 0 ${RadiusSm}`,
    borderLeft: `1px solid ${ColorGray700}`,
    borderRight: "none"
  },
  "& .buttonRight": {
    borderRadius: `0 ${RadiusSm} ${RadiusSm} 0`,
    borderLeft: "none",
    borderRight: `1px solid ${ColorGray700}`
  }
};
const iconButtonStyles = {
  backgroundColor: ColorGray200,
  borderTop: `1px solid ${ColorGray700}`,
  borderBottom: `1px solid ${ColorGray700}`,
  height: ButtonsSizeHeight,
  width: ButtonsSizeHeight,
  "&:hover": {
    backgroundColor: ColorGray400
  },
  "&:focus-visible": {
    outline: `2px solid -webkit-focus-ring-color`,
    // @ts-expect-error needed for outline in mozilla
    outline: "2px solid Highlight",
    outlineOffset: "-2px"
  }
};
const defaultIconStyle = {
  height: "20px",
  width: "20px",
  color: ColorCostcoBlue
};
const iconStyleRemove = {
  height: "24px",
  width: "24px"
};
const StyledInput = styled(Input)`
    width: 100%;
    input {
        text-align: center;
        background-color: ${ColorWhite};
        border: 1px solid ${ColorGray700};
        box-sizing: border-box;
        height: 40px;
        :focus-visible {
            outline: 2px solid Highlight;
            outline: 2px solid -webkit-focus-ring-color;
            outline-offset: -2px;
        }
    }
    &.Mui-error {
        outline-offset: -2px;
        outline: 2px solid ${ColorTextError};
    }
`;
const errorStyles = {
  marginTop: SpaceXxs
};
const addToCartBtnStyles = {
  backgroundColor: ColorCostcoBlue,
  fontSize: "14px",
  width: "100%"
};
export {
  StyledInput,
  addToCartBtnStyles,
  buttonGroupStyles,
  defaultIconStyle,
  errorStyles,
  iconButtonStyles,
  iconStyleRemove
};
